import { render } from "./MiniChatComp.vue?vue&type=template&id=1bdba189&scoped=true"
import script from "./MiniChatComp.vue?vue&type=script&lang=js"
export * from "./MiniChatComp.vue?vue&type=script&lang=js"

import "./MiniChatComp.vue?vue&type=style&index=0&id=1bdba189&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bdba189"]])

export default __exports__